module.exports = __webpack_public_path__ + "img/BLZ.ae5a8609.svg";